export default {
  'returnedPurchases.label.filterByDate': 'Filter by date',
  'returnedPurchases.label.status': 'Status',

  'returnedPurchases.option.release': 'Release',
  'returnedPurchases.option.emission': 'Emission',
  'returnedPurchases.option.creditValue': 'Credit Value',
  'returnedPurchases.option.deductedAmount': 'Deducted Amount',

  'returnedPurchases.checkbox.usedCreditDetail': 'Detail credits used',
  'returnedPurchases.checkbox.creditToUseDetail': 'Detail credits to be used',
};
